import pxToRem from "../functions/pxToRem";

const baseProperties = {
  fontFamily: '"Poppins", "Helvetica", "Arial", sans-serif',
  fontWeightLighter: 100,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  fontSizeXXS: pxToRem(10.4),
  fontSizeXS: pxToRem(12),
  fontSizeSM: pxToRem(14),
  fontSizeMD: pxToRem(16),
  fontSizeLG: pxToRem(18),
  fontSizeXL: pxToRem(20),
  fontSize2XL: pxToRem(24),
  fontSize3XL: pxToRem(30),
};

const baseHeadingProperties = {
  fontFamily: baseProperties.fontFamily,
  color: "#2b2417",
  fontWeight: baseProperties.fontWeightBold,
};

const typography = {
  fontFamily: baseProperties.fontFamily,
  fontWeightLight: baseProperties.fontWeightLight,
  fontWeightRegular: baseProperties.fontWeightRegular,
  fontWeightMedium: baseProperties.fontWeightMedium,
  fontWeightBold: baseProperties.fontWeightBold,

  h1: { ...baseHeadingProperties, fontSize: pxToRem(48), lineHeight: 1.15 },
  h2: { ...baseHeadingProperties, fontSize: pxToRem(38), lineHeight: 1.2 },
  h3: { ...baseHeadingProperties, fontSize: pxToRem(30), lineHeight: 1.25 },
  h4: { ...baseHeadingProperties, fontSize: pxToRem(24), lineHeight: 1.3 },
  h5: { ...baseHeadingProperties, fontSize: pxToRem(20), lineHeight: 1.35 },
  h6: { ...baseHeadingProperties, fontSize: pxToRem(16), lineHeight: 1.4 },

  subtitle1: { fontFamily: baseProperties.fontFamily, fontWeight: baseProperties.fontWeightRegular, fontSize: baseProperties.fontSizeLG, lineHeight: 1.5 },
  subtitle2: { fontFamily: baseProperties.fontFamily, fontWeight: baseProperties.fontWeightMedium, fontSize: baseProperties.fontSizeMD, lineHeight: 1.5 },

  body1: { fontFamily: baseProperties.fontFamily, fontWeight: baseProperties.fontWeightRegular, fontSize: baseProperties.fontSizeMD, lineHeight: 1.6 },
  body2: { fontFamily: baseProperties.fontFamily, fontWeight: baseProperties.fontWeightRegular, fontSize: baseProperties.fontSizeSM, lineHeight: 1.6 },

  button: { fontFamily: baseProperties.fontFamily, fontWeight: baseProperties.fontWeightMedium, fontSize: baseProperties.fontSizeSM, textTransform: "none", lineHeight: 1.5 },

  caption: { fontFamily: baseProperties.fontFamily, fontWeight: baseProperties.fontWeightRegular, fontSize: baseProperties.fontSizeXS, lineHeight: 1.25 },
  overline: { fontFamily: baseProperties.fontFamily },

  // Nested size scale + flat aliases — the MK component library references
  // both `typography.size.md` and `typography.fontSizeRegular` style names.
  size: {
    xxs: baseProperties.fontSizeXXS,
    xs: baseProperties.fontSizeXS,
    sm: baseProperties.fontSizeSM,
    md: baseProperties.fontSizeMD,
    lg: baseProperties.fontSizeLG,
    xl: baseProperties.fontSizeXL,
    "2xl": baseProperties.fontSize2XL,
    "3xl": baseProperties.fontSize3XL,
  },
  fontSizeRegular: baseProperties.fontSizeMD,
};

export default typography;
